import api from './client'

export const zonasApi = {
  listar: () => api.get('/zonas'),
  obtener: (id) => api.get(`/zonas/${id}`),
}

export const asignacionApi = {
  // documentos: [{ tipo: 'remito'|'nota_envio', id }]
  zonaMasiva: (zona_id, documentos) => api.post('/asignacion/zona-masiva', { zona_id, documentos }),
  // documentos: [{ tipo, id, localidad, codigo_postal }]
  autoZona: (documentos) => api.post('/asignacion/auto-zona', { documentos }),
  // Búsqueda por código (modal asignación rápida)
  buscarCodigo: (codigo) => api.get('/asignacion/buscar-codigo', { params: { codigo } }),
}
